var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var DispatchType;
(function (DispatchType) {
    DispatchType["INITHEIGHT"] = "INITHEIGHT";
    DispatchType["RENDERTR"] = "RENDERTR";
    DispatchType["RESET"] = "RESET";
})(DispatchType || (DispatchType = {}));
export var initialState = {
    rowHeight: 0,
    curScrollTop: 0,
    scrollHeight: 0,
    tableScrollY: 0,
};
export function reducer(state, action) {
    var curScrollTop = action.curScrollTop, scrollHeight = action.scrollHeight;
    var tableScrollY = action.tableScrollY, rowHeight = action.rowHeight;
    switch (action.type) {
        // Changing trs means changing the rendered list trs
        case DispatchType.RENDERTR:
            if (scrollHeight < 0)
                scrollHeight = 0;
            if (state.scrollHeight && tableScrollY === state.tableScrollY) {
                scrollHeight = state.scrollHeight;
            }
            if (state.scrollHeight && curScrollTop > state.scrollHeight) {
                curScrollTop = state.scrollHeight;
            }
            return __assign(__assign({}, state), { curScrollTop: curScrollTop, scrollHeight: scrollHeight, tableScrollY: tableScrollY });
        // Initialize the height of each row, the total height of the table, the number of bars to be rendered
        case DispatchType.INITHEIGHT:
            return __assign(__assign({}, state), { rowHeight: rowHeight });
        case DispatchType.RESET:
            return __assign(__assign({}, state), { curScrollTop: 0, scrollHeight: 0, rowHeight: 0 });
        default:
            throw new Error();
    }
}
//# sourceMappingURL=reducer.js.map